import { MutableRefObject, ReactNode } from 'react';
import TextStyle from "@able/react/dist/TextStyle";
import Spacing from "@able/react/dist/Spacing";
import InlineLink from "@able/react/dist/InlineLink";
import "./style.scss";
import { ableTextAlias } from "../util/able-migration";
import ActionButton, { ActionButtonProps } from "@able/react/dist/ActionButton";
import "./style.scss";
import usePicto, { PictoThemes } from "../util/usePicto";
import { classNames } from "../util/helpers";
import { AbleCommonProps } from '../Types';

type pictoNames = "Preferences" | "Search" | "EmptyStateTray" | "Warning" | "Error";

export type MessageContainedProps = {
    pictoName: pictoNames;
    pictoTheme?: PictoThemes;
    title: string;
    titleRef?:  MutableRefObject<null>;
    body: ReactNode;
    primaryButton?: ActionButtonProps;
    secondaryButton?: ActionButtonProps;
    stacked?: boolean;
    actionOneName?: string | undefined;
    actionTwoName?: string;
    actionOneLink?: string;
    actionTwoLink?: string;
    actionOneOnClickEvent?: (event: React.SyntheticEvent) => void;
    actionTwoOnClickEvent?: (event: React.SyntheticEvent) => void;
    /** Default value is spacing2x */
    gapInActionStackMode?: 'spacing1x' | 'spacing2x';
    titleOrder?: 1 | 2 | 3 | 4 ,
} & AbleCommonProps;

const pictoObject: Record<string, string> = {
    Preferences: "Preferences56",
    Search: "Search56",
    EmptyStateTray: "EmptyStateTray56",
    Warning: "Warning56",
    Error: "Error56"
};


/**
 * Message Contained is a simple way for users to show any inline messages.
 *
 *
 * @version 1.0.0
 */

const MessageContained = (props: MessageContainedProps) => {
    const {
        pictoName,
        pictoTheme = "blue",
        title,
        titleRef,
        body,
        primaryButton,
        secondaryButton,
        stacked,
        actionOneName,
        actionTwoName,
        actionOneLink,
        actionTwoLink,
        actionOneOnClickEvent,
        actionTwoOnClickEvent,
        titleOrder = 1,
        gapInActionStackMode = 'spacing2x',
        developmentUrl
    } = props;

    const renderActionButton = (
        <>
            {(secondaryButton || primaryButton) && <div className={classNames(stacked && "ted-ui-mc-btn-stacked", "ted-ui-mc-actions", `ted-ui-mc-actions-gap-${gapInActionStackMode}`)}>
                {primaryButton && <ActionButton developmentUrl={developmentUrl} {...primaryButton} />}
                {secondaryButton && <ActionButton developmentUrl={developmentUrl} {...secondaryButton} />}
            </div>}
        </>
    );

    const inLineLinks = actionTwoName ? (
        actionOneName ? (
            <p>
                <a href={actionOneLink} onClick={actionOneOnClickEvent}>
                    {actionOneName}
                </a>{" "}
                or{" "}
                <a href={actionTwoLink} onClick={actionTwoOnClickEvent}>
                    {actionTwoName}
                </a>
            </p>
        ) : (
            ""
        )
    ) : (
        <p>
            <a href={actionOneLink} onClick={actionOneOnClickEvent}>
                {actionOneName}
            </a>
        </p>
    );

    const pictoComponent = usePicto(pictoObject[pictoName], pictoTheme);
    return (
        <div className="tedui-message-container">
            {pictoComponent}
            <Spacing bottom="spacing1x" />
            <TextStyle colour="Default" elementRef={titleRef} className="header-text" element={`h${titleOrder}`} alias={ableTextAlias("Label") }>{title}
            </TextStyle>
            <Spacing bottom="spacing1x" />
            {body}
            <Spacing bottom="spacing2x" />
            {renderActionButton}
            {actionOneName && (
                <InlineLink variant="Default">
                    <TextStyle alias={ableTextAlias("FinePrint")}>{inLineLinks}</TextStyle>
                </InlineLink>
            )}
        </div>
    );
};
export default MessageContained;
